const classSchedule = {
  path: 'classSchedule/:myClassId',
  component: resolve => require(['../../../../components/pages/student_user/classSchedule'], resolve),
  props: true
}
export default classSchedule



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classSchedule/index.js